import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";

export const llmKeysQueryKey = ["admin", "llm-keys"];

export function useLlmKeys({ enabled = true } = {}) {
  const queryClient = useQueryClient();
  const keys = useQuery({
    queryKey: llmKeysQueryKey,
    queryFn: adminService.listLlmKeys,
    enabled,
  });

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: llmKeysQueryKey });
    queryClient.invalidateQueries({ queryKey: ["admin", "audit-logs"] });
  };

  const create = useMutation({ mutationFn: adminService.createLlmKey, onSuccess: refresh });
  const update = useMutation({
    mutationFn: ({ keyId, ...changes }) => adminService.updateLlmKey(keyId, changes),
    onSuccess: refresh,
  });
  const reorder = useMutation({ mutationFn: adminService.reorderLlmKeys, onSuccess: refresh });
  const remove = useMutation({
    mutationFn: ({ keyId, reason }) => adminService.deleteLlmKey(keyId, reason),
    onSuccess: refresh,
  });
  const test = useMutation({ mutationFn: adminService.testLlmKey });

  return {
    keys: keys.data ?? [],
    isLoading: keys.isLoading,
    error: keys.error,
    createKey: create.mutateAsync,
    updateKey: update.mutateAsync,
    reorderKeys: reorder.mutateAsync,
    deleteKey: remove.mutateAsync,
    testKey: test.mutateAsync,
    isSaving: create.isPending || update.isPending || reorder.isPending || remove.isPending,
    isTesting: test.isPending,
  };
}
